import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import {
  addWebAsset,
  fetchWebAssets,
  fetchWebAssetTemplates,
  setPageTitle,
  updateWebAsset,
  fetchWebAsset,
} from "signoxe/actions";

import { Link } from "react-router-dom";

import { Page, WebAssetTemplateEditor } from "signoxe/components";
import { Box } from "signoxe/components/layout";
import { Button, Switch } from "signoxe/components/widgets";
import {
  getAsset,
  getDataAssetTemplates,
  getWebAssetTemplates,
} from "signoxe/selectors";
import { isTemplateString } from "signoxe/utils/template";
import "./styles.scss";

class WebAssetEditPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      asset: { ...props.asset },
      useTemplate: this.shouldUseTemplate(props.asset),
    };
  }

  static defaultProps = {
    dataAsset: false,
  };

  static propTypes = {
    fetchWebAssets: PropTypes.func.isRequired,
    fetchWebAssetTemplates: PropTypes.func.isRequired,
    updateWebAsset: PropTypes.func.isRequired,
    addWebAsset: PropTypes.func.isRequired,
    setPageTitle: PropTypes.func.isRequired,
    dataAsset: PropTypes.bool,
    asset: PropTypes.object,
    params: PropTypes.object,
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    templates: PropTypes.array.isRequired,
  };

  handleCancel = () => this.props.history.push("/assets");

  handleContentChange = (content) =>
    this.setState({
      asset: {
        ...this.state.asset,
        content,
      },
    });

  handleContentEditorChange = (e) =>
    this.handleContentChange(e.currentTarget.value);

  handleNameChange = (e) =>
    this.setState({
      asset: {
        ...this.state.asset,
        name: e.currentTarget.value,
      },
    });

  handleSave = () => {
    if (this.props.asset) {
      this.props.updateWebAsset(this.props.asset.id, this.state.asset);
      this.props.history.push(`/assets/${this.props.asset.id}`);
    } else if (this.props.match.params.id === undefined) {
      this.props.addWebAsset(this.state.asset);
      this.props.history.push("/assets");
    }
  };

  handleUseTemplateChange = (e) =>
    this.setState({ useTemplate: e.target.checked });

  componentDidMount() {
    // if(this.props.asset){
    //   this.props.fetchWebAsset(false, this.props.asset.id)
    // }
    // this.props.fetchWebAssets();
    // this.props.fetchWebAssetTemplates();

    const assetType = this.props.dataAsset ? "Data" : "HTML";

    if (this.props.asset) {
      this.props.fetchWebAsset(false, this.props.asset.id);
      this.props.setPageTitle(
        `${this.props.asset.id ? "Editing" : "Adding"} ${assetType} Asset`
      );
    } else {
      this.props.setPageTitle(`Adding ${assetType} Asset`);
    }
  }

  componentWillReceiveProps(newProps) {
    if (this.props.asset !== newProps.asset) {
      this.setState({
        asset: newProps.asset,
        useTemplate: this.shouldUseTemplate(newProps.asset),
      });
    }
  }

  render() {
    if (this.props.asset === undefined && this.props.match.params.id) {
      return <div>Invalid asset.</div>;
    }

    return (
      <Page className="asset-editing-page">
        {/* {this.props.dataAsset ||
        <Box direction="row">
          <Switch className="use-template"
                  checked={this.state.useTemplate}
                  formId="use-template"
                  label="Use template"
                  onChange={this.handleUseTemplateChange}/>
        </Box>} */}
        <Box
          direction="row"
          justifyContent="flex-end"
          className="actions button-group"
        >
          <Button primary onClick={this.saveEnabled() ? this.handleSave : null}>
            Save
          </Button>
          <Button secondary onClick={this.handleCancel}>
            Cancel
          </Button>
        </Box>
        <input
          type="text"
          placeholder="Asset name"
          value={this.state.asset.name || ""}
          onChange={this.handleNameChange}
        />

        {this.state.useTemplate ? (
          <WebAssetTemplateEditor
            content={this.state.asset.content}
            templates={this.props.templates}
            dataAsset={this.props.dataAsset}
            onChange={this.handleContentChange}
          />
        ) : (
          <textarea
            placeholder="HTML Content"
            value={this.state.asset.content}
            onChange={this.handleContentEditorChange}
          />
        )}
      </Page>
    );
  }

  saveEnabled() {
    return (
      this.state.asset && this.state.asset.name && this.state.asset.content
    );
  }

  shouldUseTemplate(asset) {
    if (!asset || !asset.id) return true;

    return isTemplateString(asset.content);
  }
}

export default connect(
  (state, { match, dataAsset }) => ({
    asset: getAsset(state, parseInt(match.params.id, 10)),
    templates: dataAsset
      ? getDataAssetTemplates(state)
      : getWebAssetTemplates(state),
  }),
  {
    fetchWebAssets,
    fetchWebAsset,
    fetchWebAssetTemplates,
    updateWebAsset,
    addWebAsset,
    setPageTitle,
  }
)(WebAssetEditPage);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/WebAssetEditPage/index.js